import React from 'react';
import { Building2, Heart, Users, Award } from 'lucide-react';
import img from '../../assets/renders/VILLAVIEW0.jpeg';

const CompanyIntro = ({ className = "" }) => {
  const highlights = [
    {
      icon: Building2,
      title: "Visionary Development",
      description: "Redefining senior living through thoughtful design"
    },
    {
      icon: Heart,
      title: "Holistic Environments", 
      description: "Where comfort, care and community unite"
    },
    {
      icon: Users,
      title: "Expert Team",
      description: "Innovation, precision, and compassion combined"
    },
    {
      icon: Award,
      title: "World-Class Standards",
      description: "Setting new benchmarks in quality and lifestyle"
    }
  ];

  return (
    <div className={`pt-10 px-6 md:px-12 ${className}`}>
      <div className="max-w-7xl mx-auto">
        {/* Main Content */}
        <div className="grid lg:grid-cols-2 gap-16 items-center mb-20">
          {/* Left - Text Content */}
          <div className="space-y-8">
            <div>
              <div className="inline-flex items-center gap-2 bg-red-50 px-4 py-2 rounded-full text-[var(--primarycolor)] text-sm font-medium mb-6">
                <Building2 className="w-4 h-4" />
                About Whitespace Properties
              </div>
              
              <h2 className="text-4xl md:text-5xl font-light text-gray-900 mb-8 tracking-tight leading-tight">
                Visionary Builders of 
                <span className="text-[var(--primarycolor)] font-normal"> Tomorrow's Communities</span>
              </h2>
            </div>

            <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
              <p>
                Whitespace Properties LLP is a visionary builder and developer, founded and led by seasoned experts with decades of proven experience in real estate. With a deep understanding of design, construction, and lifestyle development, the company is committed to redefining senior living in India through thoughtfully designed retirement homes and communities.
              </p>
              
              <p>
                At Whitespace, our focus goes beyond building houses - we create holistic environments where comfort, care and community come together. The project is guided by a dedicated team that combines innovation, precision, and compassion to deliver living spaces that support dignity, independence and wellbeing.
              </p>
            </div>
          </div>

          {/* Right - Visual Element */}
          <div className="relative">
            {/* Background decorative elements */}
            {/* <div className="absolute -top-8 -left-8 w-32 h-32 bg-red-500/10 rounded-full blur-2xl"></div>
            <div className="absolute -bottom-8 -right-8 w-40 h-40 bg-red-400/8 rounded-full blur-3xl"></div> */}
            
            {/* Main visual card */}
            <div className="relative bg-white rounded-2xl p-3 sm:p-8 border border-gray-200">
              <div className="text-center">
                <h3 className="text-2xl font-semibold text-[var(--primarycolor)] mb-2">Our Vision</h3>
                <p className="text-gray-600 leading-relaxed mb-5">
                  To establish world-class retirement homes that set new benchmarks in quality, safety and lifestyle.
                </p>
                  <img src={img} alt="Our Vision" className='rounded-2xl'/>
              </div>
            </div>
          </div>
        </div>

        {/* Highlights Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {highlights.map((item, index) => {
            const IconComponent = item.icon;
            return (
              <div key={index} className="group text-center">
                <div className="w-16 h-16 bg-red-50 group-hover:bg-red-100 rounded-2xl flex items-center justify-center mx-auto mb-6 transition-all duration-300 border border-red-100 group-hover:border-red-200">
                  <IconComponent className="w-8 h-8 text-[var(--primarycolor)]" />
                </div>
                <h4 className="text-lg font-semibold text-gray-900 mb-3">{item.title}</h4>
                <p className="text-gray-600 text-sm leading-relaxed">{item.description}</p>
              </div>
            );
          })}
        </div>

        {/* Bottom Statement */}
        <div className="mt-20 text-center">
          <div className="max-w-4xl mx-auto bg-gradient-to-r from-gray-50 to-red-50/30 rounded-3xl p-12 relative overflow-hidden">
            <div className="absolute top-0 left-0 w-32 h-32 bg-red-500/5 rounded-full blur-2xl"></div>
            <div className="absolute bottom-0 right-0 w-40 h-40 bg-red-400/8 rounded-full blur-3xl"></div>
            
            <div className="relative z-10">
              <p className="text-xl md:text-2xl text-gray-800 font-light leading-relaxed">
                With Whitespace Properties, seniors and their families can be assured of a trusted partner building homes that are not just beautiful but truly meaningful.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyIntro;